import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { CcRequirementSmartCompliance } from "server/models"
import { StoreType, addModal } from "client/store"
import {
    Link,
    Default,
    TableColumn,
} from "client/components"

import Edit from "./edit"

const Columns = (
    editAccess: boolean,
) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            formatter: (compliance: CcRequirementSmartCompliance) => (
                <>
                    <Link
                        href="/#"
                        onClick={() => dispatch(addModal({
                            key: "editSmartCompliance",
                            content: <Edit complianceId={compliance.id} editAccess={editAccess} />,
                        }))}
                    >
                        {compliance.name}
                    </Link>
                    {compliance.default && <Default marginLeft />}
                </>
            ),
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
        },
    ]

    if (editAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
